import type {Configuration} from '../configuration';
import type {AxiosInstance, AxiosPromise, RawAxiosRequestConfig} from 'axios';
import {BASE_PATH, BaseAPI, operationServerMap, RequestArgs} from '../base';
import globalAxios from 'axios';
import {createRequestFunction, DUMMY_BASE_URL, setSearchParams, toPathString} from '../common';
import {Organizations, User, Tenants} from '../types';

/**
 * UserSelfServiceApi - axios parameter creator
 * @export
 */
export const UserSelfServiceApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * 查询租户列表
     * @summary 查询租户列表
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userSelfServiceFindTenants: async (
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/user/self/tenants`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 用户登出
     * @summary 用户登出
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userSelfServiceLogout: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/user/self/logout`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 用户详情
     * @summary 用户详情
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userSelfServiceMe: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/user/self`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 用户组织列表
     * @summary 用户组织列表
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userSelfServiceOrgFind: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/user/self/organizations`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * user.echo
     * @summary user.echo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userSelfServiceWsEcho: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/user.echo`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * UserSelfServiceApi - functional programming interface
 * @export
 */
export const UserSelfServiceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = UserSelfServiceApiAxiosParamCreator(configuration);
  return {
    /**
     * 查询租户列表
     * @summary 查询租户列表
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userSelfServiceFindTenants(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Tenants>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.userSelfServiceFindTenants(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['UserSelfServiceApi.userSelfServiceFindTenants']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 用户登出
     * @summary 用户登出
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userSelfServiceLogout(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.userSelfServiceLogout(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['UserSelfServiceApi.userSelfServiceLogout']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 用户详情
     * @summary 用户详情
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userSelfServiceMe(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.userSelfServiceMe(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['UserSelfServiceApi.userSelfServiceMe']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 用户组织列表
     * @summary 用户组织列表
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userSelfServiceOrgFind(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Organizations>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.userSelfServiceOrgFind(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['UserSelfServiceApi.userSelfServiceOrgFind']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * user.echo
     * @summary user.echo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userSelfServiceWsEcho(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.userSelfServiceWsEcho(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['UserSelfServiceApi.userSelfServiceWsEcho']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * UserSelfServiceApi - factory interface
 * @export
 */
export const UserSelfServiceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = UserSelfServiceApiFp(configuration);
  return {
    /**
     * 查询租户列表
     * @summary 查询租户列表
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userSelfServiceFindTenants(options?: any): AxiosPromise<Tenants> {
      return localVarFp
        .userSelfServiceFindTenants(options)
        .then(request => request(axios, basePath));
    },
    /**
     * 用户登出
     * @summary 用户登出
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userSelfServiceLogout(options?: any): AxiosPromise<void> {
      return localVarFp.userSelfServiceLogout(options).then(request => request(axios, basePath));
    },
    /**
     * 用户详情
     * @summary 用户详情
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userSelfServiceMe(options?: any): AxiosPromise<User> {
      return localVarFp.userSelfServiceMe(options).then(request => request(axios, basePath));
    },
    /**
     * 用户组织列表
     * @summary 用户组织列表
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userSelfServiceOrgFind(options?: any): AxiosPromise<Organizations> {
      return localVarFp.userSelfServiceOrgFind(options).then(request => request(axios, basePath));
    },
    /**
     * user.echo
     * @summary user.echo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userSelfServiceWsEcho(options?: any): AxiosPromise<User> {
      return localVarFp.userSelfServiceWsEcho(options).then(request => request(axios, basePath));
    },
  };
};

/**
 * UserSelfServiceApi - object-oriented interface
 * @export
 * @class UserSelfServiceApi
 * @extends {BaseAPI}
 */
export class UserSelfServiceApi extends BaseAPI {
  /**
   * 查询租户列表
   * @summary 查询租户列表
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserSelfServiceApi
   */
  public userSelfServiceFindTenants(options?: RawAxiosRequestConfig) {
    return UserSelfServiceApiFp(this.configuration)
      .userSelfServiceFindTenants(options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 用户登出
   * @summary 用户登出
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserSelfServiceApi
   */
  public userSelfServiceLogout(options?: RawAxiosRequestConfig) {
    return UserSelfServiceApiFp(this.configuration)
      .userSelfServiceLogout(options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 用户详情
   * @summary 用户详情
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserSelfServiceApi
   */
  public userSelfServiceMe(options?: RawAxiosRequestConfig) {
    return UserSelfServiceApiFp(this.configuration)
      .userSelfServiceMe(options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 用户组织列表
   * @summary 用户组织列表
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserSelfServiceApi
   */
  public userSelfServiceOrgFind(options?: RawAxiosRequestConfig) {
    return UserSelfServiceApiFp(this.configuration)
      .userSelfServiceOrgFind(options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * user.echo
   * @summary user.echo
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserSelfServiceApi
   */
  public userSelfServiceWsEcho(options?: RawAxiosRequestConfig) {
    return UserSelfServiceApiFp(this.configuration)
      .userSelfServiceWsEcho(options)
      .then(request => request(this.axios, this.basePath));
  }
}
